import React from 'react';

interface Props {
    text: string;
    bg: `dark` | `light`;
}
export const Eyebrow = ({ text, bg }: Props) => (
    <small className={`typestack-eyebrow bg-${bg}`}>{text}</small>
);
